import React from 'react';
import '../styles/Testimonials.css';

// Import existing testimonial images
let janMariImage, christianImage, bryanImage;
try {
  janMariImage = require('../assets/jan-mari-real.png');
} catch (e) {
  janMariImage = null;
}
try {
  christianImage = require('../assets/christian-honstetter.png');
} catch (e) {
  christianImage = null;
}
try {
  bryanImage = require('../assets/bryan-lantry.png');
} catch (e) {
  bryanImage = null;
}

// Blank placeholder image
const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "The only people you want to work with! So many options! Use my review... PICK TIF!",
      author: "Bryan Lantry",
      position: "CEO & Co-Founder Philtered Water LLC, Boca Raton, United States",
      avatar: bryanImage || placeholderImage
    },
    {
      quote: "They did an excellent job setting up my automation system. They were professional, knowledgeable, and explained each step clearly. The setup was efficient, and their insights were very helpful. Highly recommend Rahul and his team for any automation projects!",
      author: "Christian Honstetter",
      position: "CEO & Founder - FH Media, Munich, Germany",
      avatar: christianImage || placeholderImage
    },
    {
      quote: "They worked so fast and efficient! The only freelancers who was quick to do the job and gave clear communication. I have no complaints and would recommend them to anyone.",
      author: "Jan Mari",
      position: "CTO - Real Life University, Derby, United Kingdom",
      avatar: janMariImage || placeholderImage
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <h2>Success Stories From <span className="highlight">Business Owners Like You</span></h2>
        
        <div className="testimonials-slider">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <div className="quote-mark">"</div>
              <p className="quote">{testimonial.quote}</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <img src={testimonial.avatar} alt={testimonial.author} />
                </div>
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="metrics-banner">
          <div className="metric">
            <h3>85%</h3>
            <p>Time Saved on Social Media Management</p>
          </div>
          <div className="metric">
            <h3>3x</h3>
            <p>Average Increase in Affiliate Recruitment</p>
          </div>
          <div className="metric">
            <h3>62%</h3>
            <p>More Content Published Across Channels</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
